<h2 mat-dialog-title>Felder mappen{{ data.titel ? ' – ' + data.titel : '' }}</h2>

<mat-dialog-content class="map-dialog-content">
    <!-- Steuerung oben – immer sichtbar, kein Seitwärts-Scroll -->
    <div class="top-controls">
        <div *ngIf="loading" class="loading-hint">Lade Feldliste …</div>

        <div class="place-row">
            <mat-form-field class="place-select">
                <mat-label>Platzhalter zum Setzen</mat-label>
                <mat-select [(ngModel)]="placePlaceholder">
                    <mat-optgroup label="VetVet">
                        <mat-option *ngFor="let p of platzhalter" [value]="p.key">{{ p.label }}</mat-option>
                    </mat-optgroup>
                    <mat-optgroup *ngIf="customFields.length" label="Eigene Felder">
                        <mat-option *ngFor="let c of customFields" [value]="c.key">
                            {{ c.type === 'checkbox' ? 'Checkbox – ' : 'Freitext – ' }}{{ c.label }}
                        </mat-option>
                    </mat-optgroup>
                </mat-select>
            </mat-form-field>
            <button
                *ngIf="!placeMode"
                mat-flat-button
                color="accent"
                type="button"
                (click)="startPlaceMode()"
                [disabled]="!pdfSrc"
            >
                <mat-icon>my_location</mat-icon>
                Auf PDF klicken
            </button>
            <button *ngIf="placeMode" mat-stroked-button color="warn" type="button" (click)="cancelPlaceMode()">
                Klick-Modus abbrechen
            </button>
            <button
                mat-stroked-button
                type="button"
                (click)="previewBeispiel()"
                [disabled]="!pdfSrc || previewing"
            >
                <mat-icon>preview</mat-icon>
                Beispielvorschau
            </button>
        </div>

        <div class="custom-box">
            <div class="custom-title">Eigene Felder – anlegen, oben wählen, auf PDF setzen</div>
            <div class="custom-add">
                <mat-form-field class="type-field">
                    <mat-label>Art</mat-label>
                    <mat-select [(ngModel)]="newCustomType">
                        <mat-option value="text">Freitext</mat-option>
                        <mat-option value="checkbox">Checkbox (X/nix)</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="label-field">
                    <mat-label>Bezeichnung</mat-label>
                    <input
                        matInput
                        [(ngModel)]="newCustomLabel"
                        [placeholder]="
                            newCustomType === 'checkbox' ? 'z. B. Bestandsproblem nein' : 'z. B. Probennummer'
                        "
                    />
                </mat-form-field>
                <button mat-flat-button color="primary" type="button" (click)="addCustomField()">
                    Hinzufügen
                </button>
            </div>
            <div class="custom-chips" *ngIf="customFields.length">
                <button
                    *ngFor="let c of customFields"
                    mat-stroked-button
                    type="button"
                    class="custom-chip"
                    [class.active]="placePlaceholder === c.key"
                    (click)="placePlaceholder = c.key"
                    [matTooltip]="'Zum Setzen auswählen'"
                >
                    <mat-icon class="type-icon">{{ c.type === 'checkbox' ? 'check_box' : 'short_text' }}</mat-icon>
                    {{ c.label }}
                    <mat-icon
                        class="chip-del"
                        (click)="removeCustomField(c.key); $event.stopPropagation()"
                        >close</mat-icon
                    >
                </button>
            </div>
        </div>
    </div>

    <div class="map-body">
        <div class="pdf-pane">
            <div class="pdf-toolbar">
                <button mat-icon-button type="button" (click)="prevPage()" [disabled]="currentPage <= 1">
                    <mat-icon>navigate_before</mat-icon>
                </button>
                <span>Seite {{ currentPage }} / {{ pageCount }}</span>
                <button
                    mat-icon-button
                    type="button"
                    (click)="nextPage()"
                    [disabled]="currentPage >= pageCount"
                >
                    <mat-icon>navigate_next</mat-icon>
                </button>
                <span class="status ok" *ngIf="!pdfLoading && pdfSrc">PDF geladen</span>
                <span class="status wait" *ngIf="pdfLoading">lädt…</span>
                <span class="status err" *ngIf="placeMode">Jetzt auf die Vorschau klicken</span>
                <span class="status wait" *ngIf="dragging">ziehen…</span>
                <span class="spacer"></span>
                <button
                    *ngIf="detectedFields.length"
                    mat-button
                    type="button"
                    (click)="importDetectedFields()"
                >
                    AcroForm übernehmen
                </button>
                <button mat-button type="button" (click)="addFieldRow()">PDF-Feld manuell</button>
            </div>

            <div
                #pdfHost
                class="pdf-host"
                [class.place-mode]="placeMode"
                [class.dragging]="dragging"
            >
                <div *ngIf="pdfLoading" class="pdf-loading">PDF wird geladen …</div>
                <div *ngIf="!pdfLoading && pdfError" class="pdf-error">{{ pdfError }}</div>

                <pdf-viewer
                    *ngIf="pdfSrc"
                    [src]="pdfSrc"
                    [page]="currentPage"
                    [show-all]="false"
                    [render-text]="false"
                    [original-size]="false"
                    [fit-to-page]="false"
                    [autoresize]="true"
                    [zoom-scale]="'page-width'"
                    (after-load-complete)="onPdfLoad($event)"
                    (error)="onPdfError($event)"
                ></pdf-viewer>

                <div
                    *ngIf="placeMode && pdfSrc"
                    class="click-layer"
                    (mousedown)="onPlaceMouseDown($event)"
                ></div>
                <div *ngIf="placeDraft" class="place-draft" [ngStyle]="draftStyle()"></div>

                <div class="markers" *ngIf="pdfSrc && overlaysOnCurrentPage().length" [attr.data-tick]="layoutTick">
                    <div
                        *ngFor="let m of overlaysOnCurrentPage()"
                        class="marker"
                        [class.checkbox]="isCheckboxKey(m.placeholder)"
                        [class.signature-box]="isSignatureKey(m.placeholder) && (m.height || 0) > 8"
                        [class.dragging]="dragging && m === dragEntry"
                        [ngStyle]="markerStyle(m)"
                        [matTooltip]="platzhalterLabel(m.placeholder) + ' – ziehen zum Verschieben'"
                        (mousedown)="onMarkerMouseDown($event, m)"
                    >
                        <span class="anchor"></span>
                        <span
                            *ngIf="!isCheckboxKey(m.placeholder) && (m.width || 0) > 12"
                            class="text-block"
                            [class.signature]="isSignatureKey(m.placeholder)"
                            [ngStyle]="textBlockStyle(m)"
                        >
                            <span class="resize" (mousedown)="onWidthResizeDown($event, m)"></span>
                        </span>
                        <span class="label">{{ platzhalterLabel(m.placeholder) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="entries-pane">
            <div class="entries-title">Zuordnungen ({{ entries.length }})</div>
            <div class="entries">
                <div *ngIf="!entries.length" class="empty">Noch keine – oben Feld wählen und auf PDF klicken.</div>
                <div *ngFor="let e of entries; let i = index" class="entry">
                    <div class="entry-head">
                        <strong *ngIf="e.kind === 'overlay'">
                            {{ isCheckboxKey(e.placeholder) ? '☐/X' : 'Text' }} S{{ e.page }}
                        </strong>
                        <strong *ngIf="e.kind === 'field'">Feld {{ e.name || '…' }}</strong>
                        <button mat-icon-button type="button" (click)="removeEntry(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>

                    <mat-form-field *ngIf="e.kind === 'field'" style="width: 100%">
                        <mat-label>PDF-Feldname</mat-label>
                        <input matInput [(ngModel)]="e.name" list="acro-field-names" />
                    </mat-form-field>

                    <div *ngIf="e.kind === 'overlay'" class="overlay-meta">
                        <mat-form-field style="width: 70px">
                            <mat-label>Seite</mat-label>
                            <input matInput type="number" min="1" [max]="pageCount" [(ngModel)]="e.page" />
                        </mat-form-field>
                        <mat-form-field style="width: 70px">
                            <mat-label>Größe</mat-label>
                            <input matInput type="number" min="6" max="24" [(ngModel)]="e.size" />
                        </mat-form-field>
                        <mat-form-field *ngIf="!isCheckboxKey(e.placeholder)" style="width: 80px">
                            <mat-label>Breite</mat-label>
                            <input matInput type="number" min="0" [(ngModel)]="e.width" placeholder="pt" />
                        </mat-form-field>
                        <mat-form-field *ngIf="!isCheckboxKey(e.placeholder)" style="width: 70px">
                            <mat-label>Zeilen</mat-label>
                            <input matInput type="number" min="1" max="20" [(ngModel)]="e.lines" />
                        </mat-form-field>
                    </div>

                    <mat-form-field style="width: 100%">
                        <mat-label>Wert</mat-label>
                        <mat-select [(ngModel)]="e.placeholder">
                            <mat-option value="">— wählen —</mat-option>
                            <mat-optgroup label="VetVet">
                                <mat-option *ngFor="let p of platzhalter" [value]="p.key">{{ p.label }}</mat-option>
                            </mat-optgroup>
                            <mat-optgroup *ngIf="customFields.length" label="Eigene Felder">
                                <mat-option *ngFor="let c of customFields" [value]="c.key">
                                    {{ c.type === 'checkbox' ? 'Checkbox – ' : 'Freitext – ' }}{{ c.label }}
                                </mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <datalist id="acro-field-names">
                <option *ngFor="let f of detectedFields" [value]="f.name"></option>
            </datalist>
        </div>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="accent" type="button" [disabled]="saving" (click)="save()">
        Speichern
    </button>
</mat-dialog-actions>
